<span
  *ngIf="title"
  class="py-px px-1.5 h-[18px] min-w-20 flex justify-center items-center rounded-md text-xs border bg-white"
  [style.border-color]="color"
  [style.color]="color"
>
  {{ title }}
</span>
